/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
export function fmtData(d) {
  if (!d) return '\u2014';
  const date = new Date(d);
  if (isNaN(date)) return '\u2014';
  return date.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
export function fmtDataOra(d) {
  if (!d) return '\u2014';
  const date = new Date(d);
  if (isNaN(date)) return '\u2014';
  return date.toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}
export function relativeTime(d) {
  if (!d) return '';
  const diff = (new Date() - new Date(d)) / 1000;
  if (diff < 60) return 'adesso';
  if (diff < 3600) return `${Math.floor(diff / 60)} min fa`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} ore fa`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)} giorni fa`;
  return fmtData(d);
}
